export default "__VITE_ASSET__021b3af9__"